import React from 'react';

import IconTIProExclusive from '@components/Images/Rebranding/IconTIProExclusive';

const ProExclusiveLogo = () => {
  return (
    <div className="mx-auto mb-24 max-w-[720px] border-0 border-b-2 border-solid border-grayscale-beige pb-24 text-center sm:mb-32 sm:pb-32">
      <IconTIProExclusive className="w-[108px]" />
    </div>
  );
};

export default ProExclusiveLogo;
